import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { OrderedMap } from 'immutable';
import result from 'lodash/result';

import DownArrow from 'components/svgs/icons/down-arrow';

const propTypes = {
  vehicles: PropTypes.instanceOf(OrderedMap).isRequired,
  selectedVehicleId: PropTypes.number,
  onSelect: PropTypes.func.isRequired,
};

const defaultProps = {
  selectedVehicleId: null,
};

const LicensePlateModalDropdown = ({
  vehicles,
  onSelect,
  selectedVehicleId,
}) => {
  const vehicleOptions = vehicles.map(vehicle => (
    <MenuItem
      key={`lpmd-${vehicle.id}`}
      eventKey={vehicle.id}
      onSelect={(vehicleId) => { onSelect(vehicleId); }}
    >
      {vehicle.label}
    </MenuItem>
  )).toArray();

  const selectedVehicle = vehicles.get(result(selectedVehicleId, 'toString', null));

  return (
    <Dropdown
      id={'license-plate-modal-dropdown'}
    >
      <Dropdown.Toggle className="license-plate-modal-dropdown">
        <span className="license-plate-left">{ selectedVehicle.label }</span>
        <span className="license-plate-right"><DownArrow /></span>
      </Dropdown.Toggle>
      <Dropdown.Menu
        className={'license-plate-modal-dropdown-menu'}
      >
        { vehicleOptions }
      </Dropdown.Menu>
    </Dropdown>
  );
};

LicensePlateModalDropdown.propTypes = propTypes;
LicensePlateModalDropdown.defaultProps = defaultProps;
export default LicensePlateModalDropdown;
